module.exports = __webpack_public_path__ + "static/media/feedback.b29f51d5.png";